// context/SubSubjectsContext.js
import React, { createContext, useContext } from "react";
import { useFetchSubSubjects } from "../hooks/useFetchSubSubjects";

const SubSubjectsContext = createContext({
  data: [],
  loading: true,
  error: null,
});

export function SubSubjectsProvider({ children }) {
  const { data, loading, error } = useFetchSubSubjects();

  return (
    <SubSubjectsContext.Provider value={{ data, loading, error }}>
      {children}
    </SubSubjectsContext.Provider>
  );
}

export function useSubSubjects() {
  return useContext(SubSubjectsContext);
}